import { typeValues } from '../chat-bubble/utils';
import { defineCustomElement, getAttribute, getLiteralAttribute, NectaryElement, updateAttribute, updateLiteralAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;outline:0}#wrapper{position:relative;display:flex;flex-direction:column;gap:4px;align-items:flex-end;padding-left:72px}#stamp{display:flex;gap:4px;margin:0;font:var(--sinch-sys-font-body-xs);color:var(--sinch-sys-color-text-default)}#avatar{display:none;position:absolute;left:0;top:24px}:host([type=customer])>#wrapper{align-items:flex-start}:host([type=customer]) #avatar{display:block}</style><div id="wrapper"><div id="avatar"><slot name="avatar"></slot></div><p id="stamp"><span id="firstname"></span><span id="lastname"></span>&bull;<span id="time"></span></p><slot name="bubble"></slot></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-chat-block', class extends NectaryElement {
  #$firstName;
  #$lastName;
  #$timeStamp;
  #$bubbleSlot;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$firstName = shadowRoot.querySelector('#firstname');
    this.#$lastName = shadowRoot.querySelector('#lastname');
    this.#$timeStamp = shadowRoot.querySelector('#time');
    this.#$bubbleSlot = shadowRoot.querySelector('slot[name="bubble"]');
  }
  connectedCallback() {
    this.#$bubbleSlot.addEventListener('slotchange', this.#onBubbleSlotChange);
  }
  disconnectedCallback() {
    this.#$bubbleSlot.removeEventListener('slotchange', this.#onBubbleSlotChange);
  }
  static get observedAttributes() {
    return ['firstname', 'lastname', 'timestamp', 'type'];
  }
  attributeChangedCallback(name, _, newVal) {
    switch (name) {
      case 'firstname':
        {
          this.#$firstName.textContent = newVal;
          break;
        }
      case 'lastname':
        {
          this.#$lastName.textContent = newVal;
          break;
        }
      case 'timestamp':
        {
          this.#$timeStamp.textContent = newVal;
          break;
        }
      case 'type':
        {
          this.#updateBubbleTypes();
          break;
        }
    }
  }
  set type(value) {
    updateLiteralAttribute(this, typeValues, 'type', value);
  }
  get type() {
    return getLiteralAttribute(this, typeValues, 'type', null);
  }
  set firstName(value) {
    updateAttribute(this, 'firstname', value);
  }
  get firstName() {
    return getAttribute(this, 'firstname');
  }
  set lastName(value) {
    updateAttribute(this, 'lastname', value);
  }
  get lastName() {
    return getAttribute(this, 'lastname');
  }
  set timestamp(value) {
    updateAttribute(this, 'timestamp', value);
  }
  get timestamp() {
    return getAttribute(this, 'timestamp');
  }
  #onBubbleSlotChange = () => {
    this.#updateBubbleTypes();
  };
  #updateBubbleTypes() {
    const typeValue = getAttribute(this, 'type');
    this.#$bubbleSlot.assignedElements().forEach(el => {
      updateAttribute(el, 'data-type', typeValue);
    });
  }
});